import React from "react";
import { Tag } from "lucide-react";
import { REWARDS } from "@/constants/testIds";

/**
 * Grid of the customer's issued counter codes. Active codes get the full
 * blue-wash treatment; used/expired codes are greyed out (still visible
 * for history but visually retired).
 */
export default function ActiveCodesList({ codes = [] }) {
  if (!codes.length) {
    return (
      <div
        data-testid={REWARDS.codesList}
        className="rounded-2xl bg-white shadow-card p-6 text-center text-sm text-slate-500"
      >
        <Tag className="w-4 h-4 mx-auto mb-2 text-slate-400" />
        No redemption codes yet — redeem some points to get one!
      </div>
    );
  }
  return (
    <section data-testid={REWARDS.codesList} className="rounded-2xl bg-white shadow-card p-5 md:p-6">
      <div className="flex items-center gap-2 text-sm font-display font-bold text-slate-900 mb-3">
        <Tag className="w-4 h-4 text-[color:var(--brand-blue)]" /> Your redemption codes
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {codes.map((c) => {
          const active = c.status === "active";
          return (
            <div
              key={c.id}
              data-testid={REWARDS.codeItem(c.id)}
              className={`rounded-xl border p-4 flex items-center justify-between gap-3 ${
                active
                  ? "border-[color:var(--brand-blue)] bg-[color:var(--brand-blue-wash)]"
                  : "border-soft bg-slate-50 opacity-60"
              }`}
            >
              <div>
                <div className="font-mono font-black text-xl tracking-widest text-slate-900">
                  {c.code}
                </div>
                <div className="text-[11px] text-slate-500 mt-0.5">
                  {c.store_name || "Partner store"} · ${((c.value_cents ?? c.points ?? 0) / 100).toFixed(2)} off
                </div>
              </div>
              <span
                className={`text-[10px] font-bold uppercase tracking-[0.14em] rounded-full px-2 py-1 ${
                  active
                    ? "bg-emerald-500 text-white"
                    : "bg-slate-300 text-slate-600"
                }`}
              >
                {c.status}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
